export default __webpack_public_path__ + "static/media/news-01.5999f0d1.jpg";